import { CompanyOffer } from '../companyOffers/companyOffers.types';
import { CompanyLocation } from '../locations/locations.types';
import { CompanyPackage } from '../companyPackages/companyPackages.types';
import { CompanyAccount } from '../companyAccounts/companyAccounts.types';
import { Url } from 'url';
export type CompanyId = string;

export interface DraftCompany {
  name: string;
  phoneNumber?: string;
  location: string;
  disabled: boolean;
  isTest: boolean | number | string;
  needCustomerSession: boolean | number | string;
  checkinTime: string;
  checkoutTime: string;
  timezone: string;
  activatedAt: string;
  defaultCheckinPercentage: number;
  adult: boolean | number | string;
  trialEnabled: boolean;
  trialTime: number;
  defaultVideoQuality?: string;
  vrShop: boolean | string | number;
}

export interface DraftCompanyImages {
  name: string;
  phoneNumber?: string;
  location: string;
  disabled: boolean;
  isTest: boolean | number | string;
  needCustomerSession: boolean | number | string;
  checkinTime: string;
  checkoutTime: string;
  timezone: string;
  activatedAt: string;
  imageVer?: string;
  images: string;
  defaultCheckinPercentage: number;
  adult: boolean | number | string;
  trialEnabled: boolean;
  trialTime: number;
  defaultVideoQuality?: string;
  vrShop: boolean | string | number;
}

export enum ContractType {
  leaseContract = 'lease_contract',
  agencyContract = 'agency_contract',
  mixedContract = 'mixed_contract',
  serviceAgreement = 'service_agreement',
}

export interface CompanyDetails {
  id: string;
  legalEntityName: string;
  legalEntityAddress: string;
  address: string;
  contractLabel: string;
  contractType: ContractType;
  contractSigningDate: string;
  contractExpirationDate: string;
  headsets: number;
  agentCommission: number;
  contacts: string;
}

export interface CompanySettings {
  adult?: boolean;
  trialEnabled?: boolean;
  trialTime?: number;
  defaultVideoQuality?: string;
  vrShop?: boolean;
}

export interface DeviceScreen {
  type: string;
  online: boolean;
  offline: boolean;
}

export interface Company {
  id: CompanyId;
  phoneNumber?: string;
  disabled: boolean;
  isTest: boolean;
  isActive: boolean;
  updatedAt: string;
  createdAt: string;
  checkinTime: string;
  checkoutTime: string;
  needCustomerSession: boolean;
  timezone: string;
  name: string;
  activatedAt: string | null;
  image: string;
  settings: CompanySettings;
  location: CompanyLocation;
  accounts: CompanyAccount[];
  offers: CompanyOffer[];
  packages: CompanyPackage[];
  paymentMethods: string[];
  details: CompanyDetails[];
  defaultCheckinPercentage: number;
  deviceScreens: DeviceScreen[];
}

export interface CompanyQuery {
  isPending: boolean;
  hasError: boolean;
  query: string;
  items: (CompanyId | Company)[];
}

export interface CompaniesPayload {
  items: Company[];
  total: number;
}

export enum PaymentMethodEnum {
  reception = 'reception',
  paymentSystem = 'payment_system',
  roomBill = 'room_bill',
  vipAccess = 'vip_access',
}

export const AvailableScreens: DeviceScreen[] = [
  { type: 'games', online: true, offline: true },
  { type: 'online_theater', online: true, offline: true },
  { type: 'adult', online: true, offline: true },
  { type: 'kids', online: true, offline: true },
  { type: 'vr_world', online: true, offline: true },
  { type: 'vr_shop', online: false, offline: false },
  { type: 'casino', online: false, offline: false },
  { type: 'hotel_services', online: false, offline: false },
  { type: 'vr_tour', online: false, offline: false },
  { type: 'partner', online: false, offline: false },
  { type: 'adv_banner', online: false, offline: false },
];
